import { Avatar, Box, Typography } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import CallRecordingPlayer from "./CallRecordingPlayer";
import { formatInTenantTz } from "../utils/dateUtils";

const STATUS_LABELS = {
  ringing: "Ringing",
  answered: "Answered",
  ended: "Ended",
  missed: "Missed",
  rejected: "Rejected",
  failed: "Failed",
};
const STATUS_COLORS = {
  ringing: "#f0a020",
  answered: "#2e7d32",
  ended: "#607d8b",
  missed: "#c4515b",
  rejected: "#c4515b",
  failed: "#c4515b",
};

const formatDuration = (seconds) => {
  if (seconds === null || seconds === undefined) return "—";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};

// One call's compact activity card — status/duration/timestamp plus a
// CallRecordingPlayer when a recording exists. Extracted out of
// CallHistoryWindow.js's per-call Box (pure lift, no behavior change) so
// both it and CombinedActivityWindow.js (the All tab's merged chat+call
// feed) share one rendering implementation instead of duplicating it —
// see interleave-chat-call-activity's design.md Decision 4.
const CallActivityCard = ({ call, activeCallId, onPlay }) => (
  <Box
    sx={{
      // "inline-flex" let multiple cards sit side-by-side and wrap into a
      // grid when rendered in a list — width: "fit-content" on a
      // block-level flex keeps the shrink-to-content sizing without that,
      // so each card still starts its own line.
      display: "flex",
      width: "fit-content",
      maxWidth: { xs: "90%", md: "70%" },
      bgcolor: "#ffffff",
      border: "1px solid #eceff1",
      borderRadius: "10px",
      px: 2,
      py: 1.5,
      mb: 1.25,
      alignItems: "center",
      gap: 1.5,
    }}
  >
    <Avatar sx={{ width: 32, height: 32, bgcolor: "#e3f2fd", flexShrink: 0 }}>
      <PhoneIcon sx={{ fontSize: 16, color: "#1565c0" }} />
    </Avatar>
    <Box sx={{ minWidth: 0 }}>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography
          sx={{
            fontSize: "0.72rem",
            fontWeight: 700,
            color: STATUS_COLORS[call.status] || "#888",
            textTransform: "uppercase",
            letterSpacing: 0.3,
          }}
        >
          {STATUS_LABELS[call.status] || call.status}
        </Typography>
        <Typography sx={{ fontSize: "0.8rem", color: "#555" }}>
          {formatDuration(call.duration_seconds)}
        </Typography>
      </Box>
      <Typography sx={{ fontSize: "0.75rem", color: "#aaa", mt: 0.25 }}>
        {formatInTenantTz(call.started_at)}
      </Typography>
    </Box>
    {call.has_recording && (
      <CallRecordingPlayer
        callId={call.id}
        durationSeconds={call.duration_seconds}
        activeCallId={activeCallId}
        onPlay={onPlay}
      />
    )}
  </Box>
);

export default CallActivityCard;
